import {deepCopy} from './objects';

export function startLoading(state, keys) {
  const newState = deepCopy(state);
  keys.forEach(key => {
    newState[key] = {
      ...newState[key],
      loading: true
    };
  });
  return newState;
}

export function startError(state, key) {
  return {
    ...state,
    [key]: {
      ...state[key],
      error: true
    }
  };
}
